import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import VehicleEntryExit from "../../components/vehicle/VehicleEntryExit";
import Footer from "../../components/common/Footer";

export default function VehicleEntryExitPage() {
  const selectedApp = localStorage.getItem("selectedApp");

  return (
    <>
      <TitleBar />
      {selectedApp === "schoolTrack" ? <SchoolBusNavMenu /> : <NavMenu />}
      <VehicleEntryExit />
      <Footer />
    </>
  );
}
